import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import RowDetail from './RowDetail';


export default class List extends Component {

	constructor(props, context) {
		super(props);
		this.columnModel = [
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				viewport: 'tablet'
			}
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		this.defaultSort =  {column: 'title', 'direction': 'asc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('checkpoint.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('checkpoint.change', this.changeListener);
	}


	handleSave(data) {
		this.refs.datagrid.getWrappedInstance().refresh();
	}

	render() {	
		return (
			<Datagrid
				ref="datagrid"
				id="checkpointpopup"
				api="checkpoint.getList"
				buttons={<h5>Vyberte závady</h5>}
				filters={['fulltext']}
				filter={this.filter}
				columnModel={this.columnModel}
				defaultSort={this.defaultSort}
				expandableComponent={RowDetail}
				expandableComponentProps={{picker: true, onSave: () => this.handleSave(), onAdd: (rating, text, checkpoint) => this.props.onAdd(rating, text, checkpoint)}}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Checkpoint/PickerList.js